'use strict';

import _ from 'lodash';

import './SideMenu.less';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactCKImage from './ReactCKImage';

export default class SideMenu extends React.Component {
	render() {
		return (
			<div className="SideMenu">
				<div className="cards">
					{_.map(this.props.choices, choice => {
						const name = choice.name;
						const classes = classnames('card', this.props.selectedChoice === name && 'selected');

						return (
							<div
								className={classes}
								key={name}
								id={`SideMenu${_.upperFirst(name.replace(' ', ''))}`}
								onClick={this.props.onSelect.bind(null, choice)}
							>
								<ReactCKImage name={`SideMenu${_.upperFirst(name.replace(' ', ''))}`} />
								<div className="name">{choice.displayName || _.upperFirst(name)}</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

const ChoicePropType = PropTypes.shape({
	displayName: PropTypes.string,
	name: PropTypes.string.isRequired
});

SideMenu.propTypes = {
	onSelect: PropTypes.func.isRequired,
	choices: PropTypes.arrayOf(ChoicePropType).isRequired,
	selectedChoice: PropTypes.string.isRequired
};
